export default [
    {
        path: '/sumate',
        name: 'sumate',
        component: () => import('@/modules/Sumate'),
        meta: {
            requiresAuth: false,
            title: 'Súmate | Fundación Rebeca Lan'
        },
    }
];
